import { createContext } from "react";

const examContext = createContext();

export default examContext;
